export default {
    install(Vue, options) {
        const emit = Vue.prototype.$emit;
        Vue.prototype.$emit = function (event, ...args) {
            emit.apply(this, [event].concat(args));
            // Не забывать о том, что нужно проверять, готов ли DOM перед тем, как вешать событие
            // TODO: Подумать, как определять, что событие уже сработало на элементе (для избежания его дублирования)
            const parent = this.$parent;
            if (parent && parent.$el !== this.$el) {
                // TODO: Заменить на vanilla-trigger (найти либу или вычленить из Jquery);
                events.$emit(event, this.$el, args)
            }
        };
    }
}